export default "__VITE_ASSET__Cv7HaP9x__"